import Vue from 'vue'
import 'bootstrap'
import 'vue-select/dist/vue-select.css'
import 'vue-datetime/dist/vue-datetime.css'
import App from './App.vue'
import router from './router'

import 'ag-grid-enterprise'

import { detectMobile } from '@/libs/detect-mobile'
import vSelect from 'vue-select'

Vue.component('v-select', vSelect)

if (detectMobile()) {
  window.location.href = 'https://m.lmdelivers.com'
}

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
